export default __webpack_public_path__ + "static/media/2_templates.75b4ad38.svg";